// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_9m-0";
export var optionCard = "_9m-1";